import React from 'react';
import PropTypes from 'prop-types';
import Image1 from '@images/404-1.jpg';
import Image2 from '@images/404-2.jpg';
import Image3 from '@images/404-3.jpg';
import Image4 from '@images/404-4.jpg';
import styled from 'styled-components';

const Container = styled.div`
  margin: 1em;
  padding: 1em;
`;

const PageText = styled.p`
  @media (min-width: 768px) {
    text-align: left;
    padding-left: 1em;
  }
`;

const ImageContainer = styled.div`
  @media (min-width: 768px) {
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const ErrorImage = styled.img`
  @media (min-width: 768px) {
    object-fit: cover;
    width: 50%;
    height: 50%;
    border: 1em solid white;
  }
  width: 100%;
  height: 100%;
  border: 0.5em solid white;
`;

const browser = typeof window !== 'undefined' && window;

function NotFoundPage({ location }) {
  const Url = location.href;

  const Images = [
    { image: Image1 },
    { image: Image2 },
    { image: Image3 },
    { image: Image4 },
  ];
  const randomImageIndex = Math.floor(Math.random() * Math.floor(4));
  const ImageUrl = Images[randomImageIndex].image;

  return (
    browser && (
      <Container>
        <h1>Page Not Found</h1>
        <ImageContainer>
          <ErrorImage src={ImageUrl} />
          <PageText>
            You are trying to reach the page <strong>{Url}</strong> <br />
            You can go back to our home page to start your search again, or you
            can use the navigation at the top of this page to help you find what
            you're looking for.
          </PageText>
        </ImageContainer>
      </Container>
    )
  );
}

NotFoundPage.propTypes = {
  location: PropTypes.shape({ href: PropTypes.string.isRequired }).isRequired,
};

export default NotFoundPage;
